import { keyframes } from "@mui/system";

import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const inAnimation = keyframes`
from {
   opacity: 0;
   transform: scale(.5);
}
to {
   opacity: 1;
      transform: scale(1);

}
`;

export const loadingAnimation = (color: string) =>
  keyframes({
    from: {
      boxShadow: `0px 0px 0px 0px ${color}`,
    },
    to: {
      boxShadow: "0px 0px 0px 8px #5c61ff00",
    },
  });

export const borderAnimation = (
  color: string,
  scale: number
): SystemStyleObject<Theme> => ({
  content: "''",
  position: "absolute",
  width: "100%",
  height: "100%",
  border: `1px solid ${color}`,
  borderRadius: "100%",
  animation: `${keyframes({
    from: {
      transform: "scale(1)",
    },
    to: {
      transform: `scale(${scale})`,
      opacity: 0,
    },
  })} 2s 0.4s infinite`,
});
